import Vue from "vue";
import Vuex from "vuex";
import statInspsModule from "./modules/stat-insps";
import reportsModule from "./modules/reports";
import quotesModule from "./modules/quotes";
import clientsModule from "./modules/clients";
import portfolioModule from "./modules/portfolio";

Vue.use(Vuex);

const state = {
  alert_variant: null,
  alert_show: false,
  alert_text: [],
  note_icons: [
    { id: 1, icon: "how_to_reg" },
    { id: 2, icon: "face" },
    { id: 3, icon: "build" }
  ],
  state: [
    { id: 1, name: "active", colour: "success" },
    { id: 2, name: "archived", colour: "warning" },
    { id: 3, name: "deleted", colour: "danger" }
  ]
};
const getters = {
  noteIcons: state => noteTypeId => {
    return state.note_icons.find(li => li.id === noteTypeId).icon;
  },
  state: state => stateId => {
    return state.state.find(s => s.id === stateId);
  }
};
const actions = {
  SHOW_ERROR_ALERT(context, payload) {
    context.commit("SHOW_ERROR_ALERT", payload);
  },
  RESET_ALERT(context) {
    context.commit("RESET_ALERT");
  }
};
const mutations = {
  SHOW_ERROR_ALERT(state, payload) {
    state.alert_variant = "danger";
    state.alert_show = true;
    state.alert_text = payload;
  },
  RESET_ALERT(state) {
    state.alert_variant = null;
    state.alert_show = false;
    state.alert_text = [];
  }
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    "stat-insp": statInspsModule,
    report: reportsModule,
    quote: quotesModule,
    client: clientsModule,
    portfolio: portfolioModule
  }
});
